import React from 'react';
import { Languages } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { usePreferences } from '../context/PreferencesContext';
import { Label } from './ui/label';
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from './ui/select';

const LANGS = [
  { code: 'fr', tk: 'settings.language_fr' },
  { code: 'ar', tk: 'settings.language_ar' },
  { code: 'en', tk: 'settings.language_en' },
];

export const LanguageSwitcher = ({ compact = false }) => {
  const { t } = useTranslation();
  const { preferences, setLanguage } = usePreferences();

  return (
    <div className={compact ? '' : 'space-y-2'} data-testid="language-switcher">
      {!compact && (
        <Label className="text-sm text-text-secondary flex items-center gap-2">
          <Languages className="w-4 h-4 text-primary" />
          {t('settings.language')}
        </Label>
      )}
      <Select value={preferences.language} onValueChange={setLanguage}>
        <SelectTrigger className="bg-background border-border" data-testid="language-select">
          <SelectValue />
        </SelectTrigger>
        <SelectContent className="bg-surface border-border">
          {LANGS.map((l) => (
            <SelectItem key={l.code} value={l.code} data-testid={`language-option-${l.code}`}>
              {t(l.tk)}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      {!compact && (
        <p className="text-xs text-text-muted">{t('settings.language_help')}</p>
      )}
    </div>
  );
};
